import { useLanguage } from '../../context/LanguageContext';
import { translations } from '../../helpers/language';

const EmpoweringSection = () => {
  const { language } = useLanguage();
  const t = translations[language].empowering;

  return (
    <section className="secction-image" data-aos="fade-up">
      <h1 className="title-img">{t.text}</h1>
    </section>
  );
};

export default EmpoweringSection;
